// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2frLa","inputWrap":"styles_inputWrap__9RerW","input":"styles_input__3BcpW"};